import React from "react";
export function YearTrack() {
  return <div className="mt-12 rounded-[14px] border border-white/10 bg-navy p-5 sm:p-8 lg:mt-16" data-id="element-245" data-mp="1ly1v7si1ma5s">
      <h3 className="font-display text-[28px] font-bold uppercase leading-none text-ice" data-id="element-246" data-mp="1rs7ga27do4lc">
        12 lessons. <span className="text-cyan" data-id="element-247" data-mp="1d3ktxgjc2ckm">One clear progression.</span>
      </h3>
      <p className="mt-3 text-[15px] leading-relaxed text-ice/70" data-id="element-248" data-mp="1i1w63xx3oz60">
        Teach in sequence and adapt the pace to your group and timetable.
      </p>
      <ol className="mt-6 grid grid-cols-3 gap-2 sm:grid-cols-4 lg:grid-cols-12" data-id="element-249" data-mp="1929chyam4xni">
        {Array.from({
        length: 12
      }, (_, i) => <li key={i} className="relative overflow-hidden rounded-[8px] border border-white/10 bg-navy-800 px-3 pb-3 pt-4" data-id="element-250" data-mp="u5s3hdpwbv44">
            <span className="absolute inset-x-0 top-0 h-1 bg-cyan" aria-hidden="true" data-id="element-251" data-mp="z4lgz656nm4a" />
            <span className="block font-display text-[26px] font-extrabold leading-none text-ice" data-id="element-252" data-mp="2okb57e2m5ul3">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.08em] text-ice/65" data-id="element-253" data-mp="1esnhk49okiqc">
              Lesson
            </span>
          </li>)}
      </ol>
    </div>;
}